import React, { Fragment, useState, useEffect } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { CardFooter, Row, Input, InputGroup, } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import DatePicker from "react-datepicker";
import moment from "moment";
import Table from "./Table";
import Dropdown from 'react-dropdown-select';
import { useCommunityContractList, useDocumentList } from "Api/Coordinator/Beheer/DocumentenBeheer";

function Documentenbeheer() {

    const [contractList, setContractList] = useState([]);
    const [selectedOrganization, setSelectedOrganization] = useState('');
    const [pageSizeCount, setPageSizeCount] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [filterData, setFilterData] = useState({
        community: '',
        user: '',
        contractType: '',
    });

    const [payload, setPayload] = useState({
        "iCommunityId": null,
        "contracttype": "",
        "documentType": "all",
        "startPeriod": moment().format('DD-MM-YYYY'),
        "lastPeriod": moment(moment()).add(1, 'month').format('DD-MM-YYYY'),
        "pageSize": 20,
        "page": 1
    });


    const {
        trigger: getDocuments,
        isMutating: isLoading,
    } = useDocumentList();

    const [documentResponse, setDocumentResponse] = useState(null);

    useEffect(() => {
        getDocuments({
            data: payload,
        })
            .then((response) => {
                setDocumentResponse(response);
            })
            .catch(console.error);
    }, [payload]);

    const tableData =
        documentResponse?.data?.lists || [];

    const totalPageCount =
        documentResponse?.data?.pageCount || 0;
  const totalCount=documentResponse?.data?.totalCount;

    const {
        data: communityResponse,
        isLoading: communityLoading,
    } = useCommunityContractList();

    const communities = communityResponse?.data || [];


    useEffect(() => {
        if (filterData?.community && communities?.length > 0) {
            const data = communities.find(item => filterData.community === String(item.iCommunityId))
            if (data) {
                setContractList(data?.contracttypes)
            }
        }
    }, [filterData?.community, communities])

    const filterHandler = (type, value) => {
        (value === '' && type === 'contractType') && setContractList([]);

        setFilterData((prev) => {
            return { ...prev, [type]: value }
        })
    }

    const itemRenderer = ({ item, methods }) => {
        const isSelected = methods.isSelected(item);

        return (
            <div
                key={item.value}
                className={`dropdown-item${isSelected ? ' selected' : ''}`}
                onClick={() => methods.addItem(item)}
            >
                <input
                    type="checkbox"
                    checked={isSelected}
                    readOnly
                    style={{ marginRight: '8px' }}
                />
                {item.label}
            </div>
        );
    };

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                {
                    <div className="overig-export">
                        <Row className="mb-5">
                            <Table data={tableData} setPayload={setPayload} showLoader={isLoading} setPageSizeCount={setPageSizeCount} pageSizeCount={pageSizeCount} setPageNumber={setPageNumber} pageNumber={pageNumber} totalPageCount={totalPageCount} totalCount={totalCount} />
                        </Row>
                    </div>
                }
            </TransitionOnLoad>
            <div className="chat-layout-footer documentenbeheer-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex gap-3 mr-4">
                        <div className="d-flex gap-4 mb-0 align-items-end">
                            <div className="mb-0 footer-box">
                                <InputGroup >
                                    <Input
                                        id="sOrganization"
                                        name="sOrganization"
                                        type="select"
                                        value={filterData.community}
                                        onChange={(e) => {
                                            filterHandler('community', e.target.value);
                                            filterHandler('contractType', '')
                                            setPayload((prev) => {
                                                return { ...prev, iCommunityId: Number(e.target.value), page: 1, contracttype: '' }
                                            })
                                            setPageNumber(1);
                                        }}
                                    >
                                        <option value={''}>Alle besturen</option>
                                        {communities.map((option) =>
                                            <option key={option.iCommunityId} value={option.iCommunityId}>{option.vCommunityName}</option>
                                        )}
                                    </Input>
                                </InputGroup>
                            </div>

                            <div className="footer-box">
                                <Dropdown
                                    multi
                                    options={contractList?.map(item => ({
                                        value: item.id,
                                        label: `${item.abbr} - ${item.name}`,
                                    }))}
                                    onChange={e => {
                                        const selectedIds = e.map(item => item?.value).join(",");
                                        setPayload(prev => ({
                                            ...prev,
                                            contracttype: selectedIds,
                                            page: 1
                                        }));
                                        setPageNumber(1);
                                    }}
                                    itemRenderer={itemRenderer}
                                    values={[]}
                                    placeholder="Alle Contracttypen"
                                    dropdownPosition="top"
                                    closeOnScroll={true}
                                    closeOnSelect={false}
                                    keepSelectedInList={true}
                                    contentRenderer={() => <div style={{ color: '#878EA6' }}>Alle</div>}
                                    dropdownHandle={false}
                                    dropdownGap={5}
                                    className="dropdown-up multiselect"
                                    noDataLabel="Geen opties beschikbaar"
                                    searchable={true}
                                />

                            </div>

                            <div className="mb-0 footer-box">
                                <InputGroup >
                                    <Input
                                        id="documentType"
                                        name="documentType"
                                        type="select"
                                        value={selectedOrganization}
                                        onChange={e => {
                                            setSelectedOrganization(parseInt(e.target.value));
                                            setPayload((prev) => {
                                                return { ...prev, documentType: e.target.value, page: 1 }
                                            })
                                            setPageNumber(1);
                                        }}
                                    >
                                        <option value={'all'}>Alle documenten</option>
                                        <option value={"1"}>Eerste inzet</option>
                                        <option value={"2"}>Nieuwe documenten</option>
                                    </Input>
                                </InputGroup>
                            </div>

                            <div className="footer-box d-flex">
                                <div className="d-flex align-items-center me-1">Begindatum</div>
                                <div className="custom-Data-picker">
                                    <DatePicker
                                        selected={payload?.startPeriod ? moment(payload?.startPeriod, 'DD-MM-YYYY').toDate() : null}
                                        onSelect={(e) => {
                                            const newStart = moment(e);
                                            const newEnd = moment(e).add(1, 'month');
                                            setPayload((prev) => ({
                                                ...prev,
                                                startPeriod: newStart.format('DD-MM-YYYY'),
                                                lastPeriod: newEnd.format('DD-MM-YYYY'), // auto update end date
                                                page: 1
                                            }));
                                            setPageNumber(1);
                                        }}
                                        placeholderText={'dd-mm-jjjj'}
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control w-100 footer-field-min-width"
                                        locale="nl"
                                        showIcon
                                        toggleCalendarOnIconClick
                                        icon={
                                            <svg className="svg-pointer" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.99998 0.666687V2.00002H8.99998V0.666687H10.3333V2.00002H13C13.3682 2.00002 13.6666 2.2985 13.6666 2.66669V13.3334C13.6666 13.7016 13.3682 14 13 14H0.99998C0.631793 14 0.333313 13.7016 0.333313 13.3334V2.66669C0.333313 2.2985 0.631793 2.00002 0.99998 2.00002H3.66665V0.666687H4.99998ZM12.3333 7.33335H1.66665V12.6667H12.3333V7.33335ZM4.33331 8.66669V10H2.99998V8.66669H4.33331ZM7.66665 8.66669V10H6.33331V8.66669H7.66665ZM11 8.66669V10H9.66665V8.66669H11ZM3.66665 3.33335H1.66665V6.00002H12.3333V3.33335H10.3333V4.66669H8.99998V3.33335H4.99998V4.66669H3.66665V3.33335Z" fill="#026094" />
                                            </svg>
                                        }
                                    />
                                </div>
                            </div>

                            <div className="footer-box d-flex">
                                <div className="d-flex align-items-center me-1">Einddatum</div>
                                <div className="custom-Data-picker">
                                    <DatePicker
                                        selected={payload?.lastPeriod ? moment(payload?.lastPeriod, 'DD-MM-YYYY').toDate() : null}
                                        onSelect={(e) => {
                                            const newEnd = moment(e);
                                            const minEnd = moment(payload.startPeriod, 'DD-MM-YYYY').add(1, 'month');

                                            // Only allow if selected end date is >= start + 1 month
                                            if (newEnd.isSameOrAfter(minEnd, 'day')) {
                                                setPayload((prev) => ({
                                                    ...prev,
                                                    lastPeriod: newEnd.format('DD-MM-YYYY'),
                                                    page: 1
                                                }));
                                                setPageNumber(1);
                                            }
                                        }}
                                        minDate={moment(payload.startPeriod, 'DD-MM-YYYY').add(1, 'month').toDate()}
                                        placeholderText={'dd-mm-jjjj'}
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control w-100 footer-field-min-width"
                                        locale="nl"
                                        showIcon
                                        toggleCalendarOnIconClick
                                        icon={
                                            <svg className="svg-pointer" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.99998 0.666687V2.00002H8.99998V0.666687H10.3333V2.00002H13C13.3682 2.00002 13.6666 2.2985 13.6666 2.66669V13.3334C13.6666 13.7016 13.3682 14 13 14H0.99998C0.631793 14 0.333313 13.7016 0.333313 13.3334V2.66669C0.333313 2.2985 0.631793 2.00002 0.99998 2.00002H3.66665V0.666687H4.99998ZM12.3333 7.33335H1.66665V12.6667H12.3333V7.33335ZM4.33331 8.66669V10H2.99998V8.66669H4.33331ZM7.66665 8.66669V10H6.33331V8.66669H7.66665ZM11 8.66669V10H9.66665V8.66669H11ZM3.66665 3.33335H1.66665V6.00002H12.3333V3.33335H10.3333V4.66669H8.99998V3.33335H4.99998V4.66669H3.66665V3.33335Z" fill="#026094" />
                                            </svg>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </CardFooter>
            </div>
        </Fragment>
    );
}
export default Documentenbeheer;
